import { SectionProps } from '../types';
import { StyledDefaultSection } from './style';

export const DefaultSection = ({ sectionName, image }: SectionProps) => {
    return (
        <StyledDefaultSection className={'section-default'}>
            {image && (
                <div>
                    <img
                        className={'section-default__prefix-image'}
                        src={image}
                        alt={sectionName + `prefix image`}
                    />
                </div>
            )}
            <span className={'section-default__section-name'}>
                {sectionName}
            </span>
            {image && (
                <div>
                    <img
                        className={'section-default__suffix-image'}
                        src={image}
                        alt={sectionName + `prefix image`}
                    />
                </div>
            )}
        </StyledDefaultSection>
    );
};

export default DefaultSection;
